module.exports = __webpack_public_path__ + "static/media/chocolate-chunk-brookie.c2d2e2c1.png";